import React from 'react';

class PaymentPayPal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      paypal_url: '',
      paypal_payment_enabled: false,
      payment_button_enabled: true,
      loading: false,
    };

    this.getPayPalPaymentUrl = this.getPayPalPaymentUrl.bind(this);
    this.processPayPalPayment = this.processPayPalPayment.bind(this);
  }
  getPayPalPaymentUrl() {
    let details = {
      name: this.props.name,
      email: this.props.email,
    };

    $.ajax({
      url: this.props.paypalPaymentUrl,
      data: details,
      dataType: 'json',
      success: url => {
        this.props.showDetailErrors(false, []);
        this.setState(
          {
            paypal_payment_enabled: true,
          },
          () => {
            location.href = decodeURIComponent(url.url);

            setTimeout(() => {
              this.setState({ loading: false });
            }, 5000);
          },
        );
      },
      error: e => {
        this.props.showDetailErrors(true, e.responseText);
        console.log('Error getting PayPal Url');
        this.setState({
          paypal_url: '',
          paypal_button_enabled: true,
          paypal_payment_enabled: false,
          loading: false,
        });

        this.props.setPaymentStatus(false);
      },
    });
  }
  processPayPalPayment() {
    this.props.setPaymentStatus(true);
    this.setState({ loading: true, paypal_button_enabled: false }, () => {
      this.getPayPalPaymentUrl();
    });
  }
  render() {
    var loading =
      this.state.loading === true ? (
        <div className="loader paypal">Loading....</div>
      ) : (
        ''
      );
    var showPaymentDisplayError = this.props.show_payment_display_error && (
      <div className="showPaymentDisplayError">
        {this.props.payment_display_errors.map((errorMessage, index) => (
          <p key={index}>{errorMessage}</p>
        ))}
      </div>
    );
    return (
      <div className="checkout-sub-panel payment">
        {this.props.show_payment_display_error ? (
          showPaymentDisplayError
        ) : (
          <div className="paypal-payment-summary">
            <div className="paypal-warning">
              <p>
                <strong>You will be redirected to PayPal.</strong>
              </p>
              <div className="paypal-nav-away">
                <img
                  src={this.props.assets.misc.paypalWarning}
                  className="error-icon"
                />

                <div>
                  <p className="main-warning">
                    Please{' '}
                    <strong>do not close the window or navigate away</strong>{' '}
                    from the page.
                  </p>
                  <p>This may cause multiple payments to be taken.</p>
                </div>
              </div>
            </div>
            <p>
              Your PayPal account will be charged:{' '}
              <strong>&pound;{this.props.paymentTotal}</strong> for your
              delivery items and delivery charge (if applicable).
            </p>
            <div>
              <button
                className="paypal-pay-button"
                onClick={this.processPayPalPayment}
                disabled={this.state.paypal_button_enabled}>
                Pay via PayPal
              </button>
            </div>
          </div>
        )}

        {loading}
      </div>
    );
  }
}

export default PaymentPayPal;
